export default "__VITE_ASSET__bfc17413__"